import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GCADAConfigService } from '@GCADA/services/config.service';

@Component({
    selector: 'home-vertical-layout',
    templateUrl: './home-vertical-layout.component.html',
    styleUrls: ['./home-vertical-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomeVerticalLayoutComponent implements OnInit, OnDestroy {

    public GCADAConfig: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {GCADAConfigService} _GCADAConfigService
     */
    constructor(private _GCADAConfigService: GCADAConfigService) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._GCADAConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.GCADAConfig = config;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
